import { render, staticRenderFns } from "./RsaPazienteStoricoStatiSettingListComponent.vue?vue&type=template&id=1e8635e8"
import script from "./RsaPazienteStoricoStatiSettingListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteStoricoStatiSettingListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports